// Chart tracking (docs/plans/phase2-medical-records-charts.md §3). Internal IDs only in
// addresses; names and reasons travel in bodies.
import { queryOptions } from '@tanstack/react-query';
import {
  chartListSchema,
  patientChartSchema,
  recordsSettingsSchema,
  type ChartLocationBody,
  type IssueChartBody,
  type OpenChartBody,
  type RecordsSettingsBody,
  type ReturnChartBody,
} from '@wodi/shared';

import { api } from './client.ts';

export const chartKeys = {
  all: ['charts'] as const,
  patient: (patientId: string) => ['charts', 'patient', patientId] as const,
  list: (state: 'out' | 'overdue') => ['charts', 'list', state] as const,
  settings: ['charts', 'settings'] as const,
};

export const patientChartQuery = (patientId: string) =>
  queryOptions({
    queryKey: chartKeys.patient(patientId),
    queryFn: () => api('GET', `/patients/${patientId}/chart`, { schema: patientChartSchema }),
  });

export const chartListQuery = (state: 'out' | 'overdue') =>
  queryOptions({
    queryKey: chartKeys.list(state),
    queryFn: () => api('GET', `/charts?state=${state}`, { schema: chartListSchema }),
  });

export const recordsSettingsQuery = queryOptions({
  queryKey: chartKeys.settings,
  queryFn: () => api('GET', '/settings/records', { schema: recordsSettingsSchema }),
});

export const openChart = (patientId: string, body: OpenChartBody) =>
  api('POST', `/patients/${patientId}/chart`, { body, schema: patientChartSchema });

export const issueChart = (chartId: string, body: IssueChartBody) =>
  api('POST', `/charts/${chartId}/issue`, { body, schema: patientChartSchema });

export const returnChart = (chartId: string, body: ReturnChartBody) =>
  api('POST', `/charts/${chartId}/return`, { body, schema: patientChartSchema });

export const saveRecordsSettings = (body: RecordsSettingsBody) =>
  api('PUT', '/settings/records', { body, schema: recordsSettingsSchema });

export const createChartLocation = (body: ChartLocationBody) =>
  api('POST', '/settings/chart-locations', { body, schema: recordsSettingsSchema });

export const updateChartLocation = (id: string, body: ChartLocationBody) =>
  api('PUT', `/settings/chart-locations/${id}`, { body, schema: recordsSettingsSchema });
